var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox bill-type" },
    [
      _c(
        "el-card",
        { staticClass: "normal-page" },
        [
          _c("oaFromBox", {
            attrs: {
              isViewSearch: false,
              search: _vm.search,
              title: _vm.$route.meta.title,
              total: _vm.total,
              treeData: _vm.treeData,
              treeDefault: _vm.treeDefault,
              btnText: "新建项目",
            },
            on: {
              addDataFn: _vm.addProgram,
              confirmData: _vm.confirmData,
              treeChange: _vm.treeChange,
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "mt10",
            },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.tableData,
                    "header-cell-style": { background: "#f7fbff" },
                    height: _vm.tableHeight,
                    "default-expand-all": "",
                    "row-key": "id",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "项目编号", prop: "ident", width: "120" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "name", label: "项目名称", width: "450" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              { staticClass: "flex" },
                              [
                                _c("i", {
                                  staticClass: "iconfont iconxiangmuguanli",
                                }),
                                _vm._v(" "),
                                scope.row.name.length < 18
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "point line1",
                                        on: {
                                          click: function ($event) {
                                            return _vm.goTask(scope.row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(scope.row.name || "- -") +
                                            "\n              "
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "el-popover",
                                      {
                                        attrs: {
                                          placement: "top",
                                          width: "250",
                                          trigger: "hover",
                                        },
                                      },
                                      [
                                        _c("div", [
                                          _vm._v(
                                            _vm._s(scope.row.name || "- -")
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "line1 point",
                                            staticStyle: {
                                              "max-width": "200px",
                                            },
                                            attrs: { slot: "reference" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.goTask(scope.row)
                                              },
                                            },
                                            slot: "reference",
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  scope.row.name || "- -"
                                                ) +
                                                "\n                "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "状态",
                      prop: "status",
                      "min-width": "120",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.status == 1
                              ? _c(
                                  "el-tag",
                                  {
                                    attrs: { effect: "plain", type: "warning" },
                                  },
                                  [_vm._v("已暂停")]
                                )
                              : scope.row.status == 2
                              ? _c(
                                  "el-tag",
                                  { attrs: { effect: "plain", type: "info" } },
                                  [_vm._v("已关闭")]
                                )
                              : scope.row.end_date &&
                                _vm.nowTime() > scope.row.end_date
                              ? _c(
                                  "el-tag",
                                  {
                                    attrs: { effect: "plain", type: "danger" },
                                  },
                                  [_vm._v("已延期")]
                                )
                              : scope.row.start_date &&
                                _vm.nowTime() < scope.row.start_date
                              ? _c(
                                  "el-tag",
                                  {
                                    attrs: { effect: "plain", type: "success" },
                                  },
                                  [_vm._v("待开始")]
                                )
                              : _c("el-tag", { attrs: { effect: "plain" } }, [
                                  _vm._v("进行中"),
                                ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "负责人",
                      prop: "admins",
                      "min-width": "140",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("img", {
                              staticClass: "img",
                              attrs: {
                                src: scope.row.admins[0].avatar,
                                alt: "",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(scope.row.admins[0].name)),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "计划开始",
                      prop: "start_date",
                      "min-width": "140",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(_vm._s(scope.row.start_date || "--")),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "计划结束",
                      prop: "end_date",
                      "min-width": "140",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(_vm._s(scope.row.end_date || "--")),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "未完成/总任务数",
                      prop: "task_statistics",
                      "min-width": "120",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.task_statistics
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.task_statistics.incomplete
                                    ) +
                                      "/" +
                                      _vm._s(scope.row.task_statistics.total)
                                  ),
                                ])
                              : _c("span", [_vm._v("--")]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "paginationClass page-fixed" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.tableFrom.page,
                  "page-size": _vm.tableFrom.limit,
                  "page-sizes": [15, 20, 30],
                  total: _vm.total,
                  layout: "total, sizes,prev, pager, next, jumper",
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          attrs: {
            "before-close": _vm.handleClose,
            visible: _vm.taskDrawer,
            "wrapper-closable": false,
            size: "1120px",
            title: "新建项目",
          },
          on: {
            "update:visible": function ($event) {
              _vm.taskDrawer = $event
            },
          },
        },
        [
          _vm.taskDrawer
            ? _c("add-program", {
                ref: "addProgram",
                attrs: { customer: _vm.customerList, type: "edit" },
                on: {
                  getTableData: _vm.getTableData,
                  handleClose: _vm.handleClose,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }